import Storage from "./Storage";
import { user } from './UserStorage';
import { PROFILE_KEY } from './constants';
const _ = require('lodash');

class ProfileStorage extends Storage {
	constructor() {
		super(PROFILE_KEY);
		this.profile = {};
		this._parse();
	}

	_parse() {
		try {
			this.profile = JSON.parse(this._storage) || {}
		} catch (error) {

		}
	}

	save() {
		this._storage = JSON.stringify(this.profile);
		super.save()
	}

	reset() {
		this.profile = {}
		this._storage = {}
		this._parse();
	}

	get authAPI() {
		return _.get(this.profile, `${this.username}.authAPI`, '');
	}

	set authAPI(obj) {
		_.set(this.profile, [this.username, 'authAPI'], obj);
	}

	get username() {
		return user.username;
	}

	set sessionId(s) {
		_.set(this.profile, [this.username, 'sessionId'], s);
	}

	get sessionId() {
		return _.get(this.profile, `${this.username}.sessionId`, '');
	}

	set token(t) {
		_.set(this.profile, [this.username, 'authAPI', 'token'], t);
	}

	get token() {
		return _.get(this.profile, `${this.username}.authAPI.token`, '');
	}

	set authenKey(obj) {
		_.set(this.profile, [this.username, 'authenKey'], obj);
	}

	get authenKey() {
		return _.get(this.profile, `${this.username}.authenKey`, '');
	}

	get apisec() {
		return _.get(this.profile, `${this.username}.authenKey.apisec`, '');
	}

	get publicKey() {
		return _.get(this.profile, `${this.username}.authenKey.publicKey`, '');
	}

	set changeDomain(obj) {
		_.set(this.profile, [this.username, 'changeDomain'], obj);
	}

	get changeDomain() {
		return _.get(this.profile, `${this.username}.changeDomain`, '');
	}

	set notification(boolean) {
		_.set(this.profile, [this.username, 'notification'], boolean);
		this.save();
	}

	get notification() {
		return _.get(this.profile, `${this.username}.notification`, false);
	}

	set isSendDeliveredSeen(boolean) {
		_.set(this.profile, [this.username, 'isSendDeliveredSeen'], boolean);
	}

	get isSendDeliveredSeen() {
		return _.get(this.profile, `${this.username}.isSendDeliveredSeen`, false);
	}

	set isHighPhotoQuality(boolean) {
		_.set(this.profile, [this.username, 'isHighPhotoQuality'], boolean);
		this.save()
	}

	get isHighPhotoQuality() {
		return _.get(this.profile, `${this.username}.isHighPhotoQuality`, false);
	}

	get restoreStatus() {
		return _.get(this.profile, `${this.username}.restoreStatus`, undefined);
	}

	set restoreStatus(str) {
		_.set(this.profile, [this.username, 'restoreStatus'], str);
		this.save()
	}

	get opr() {
		return _.get(this.profile, `${this.username}.changeDomain.opr`, undefined);
	}

	set opr(str) {
		_.set(this.profile, [this.username, 'changeDomain', 'opr'], str);
	}

	get lastUpdateContacts() {
		return _.get(this.profile, `${this.username}.lastUpdateContacts`, undefined);
	}

	set lastUpdateContacts(str) {
		_.set(this.profile, [this.username, 'lastUpdateContacts'], str);
		this.save()
	}

	get listBlockChat() {
		return _.get(this.profile, `${this.username}.listBlockChat`, []);
	}

	set listBlockChat(s) {
		_.set(this.profile, [this.username, 'listBlockChat'], s);
		this.save()
	}

	get getMucRoomList() {
		return _.get(this.profile, `${this.username}.getMucRoomList`, false);
	}

	set getMucRoomList(isGetMucRoomList) {
		_.set(this.profile, [this.username, 'getMucRoomList'], isGetMucRoomList);
		this.save()
	}

	get pinThreadCount() {
		return _.get(this.profile, `${this.username}.pinThreadCount`, 0);
	}

	set pinThreadCount(count) {
		_.set(this.profile, [this.username, 'pinThreadCount'], count);
		this.save()
	}

	get settings() {
		return _.get(this.profile, `${this.username}.settings`, {});
	}

	set settings(settings) {
		_.set(this.profile, [this.username, 'settings'], settings);
		this.save()
	}

	set deniedNotification(boolean) {
		_.set(this.profile, [this.username, 'deniedNotification'], boolean);
		this.save();
	}

	get deniedNotification() {
		return _.get(this.profile, `${this.username}.deniedNotification`, false);
	}

	get loggingEnabled() {
		return _.get(this.profile, `${this.username}.loggingEnabled`, {});
	}

	set loggingEnabled(loggingEnabled) {
		_.set(this.profile, [this.username, 'loggingEnabled'], loggingEnabled);
		this.save()
	}

	get logDebbugEnabled() {
		return _.get(this.profile, `${this.username}.logDebbugEnabled`, false);
	}

	set logDebbugEnabled(logDebbugEnabled) {
		_.set(this.profile, [this.username, 'logDebbugEnabled'], logDebbugEnabled);
		this.save()
	}

	get preKeyInfo() {
		return _.get(this.profile, `${this.username}.preKeyInfo`, {});
	}

	set preKeyInfo(preKeyInfo) {
		_.set(this.profile, [this.username, 'preKeyInfo'], preKeyInfo);
		this.save()
	}

	get uuid() {
		return _.get(this.profile, `${this.username}.uuid`, '');
	}

	set uuid(uuid) {
		_.set(this.profile, [this.username, 'uuid'], uuid);
	}

	get retryIndexedDBCOunt() {
		return _.get(this.profile, `${this.username}.retryIndexedDBCOunt`, '');
	}

	set retryIndexedDBCOunt(count) {
		_.set(this.profile, [this.username, 'retryIndexedDBCOunt'], count);
		this.save()
	}

}

export default ProfileStorage;
export const profile = new ProfileStorage();
